import { AssignStrategy } from "../assign-strategy/assign-strategy";
import { PerformerInfo } from "../performer/entities/performer-info.entity";

export class ParticipantInfo {
    constructor() {
        this.assignStrategy = new AssignStrategy();
        this.humanPerformerList = new Array();
        this.potentialOwnerList = new Array();
        this.isAllScope = false;
    }
    assignStrategy: AssignStrategy;
    humanPerformerList: Array<Participant>;
    potentialOwnerList: Array<Participant>;
    isAllScope: boolean;
}

export class Participant {
    id: string;
    type: string;
    condition?: string;
    order?: number;
}


export class UserParticipant extends Participant {
    performerId: string;
    performerName: string;
    performerCode?: string;
    orgId?: string;
    orgName?: string;
    orgType?: string;
    tag?: string;
}

export class VariableParticipant extends UserParticipant {
    name: string;
    varValue: string;
    varType: string;
    relation: string;
}

export class PositionParticipant extends UserParticipant {
    positionType: string;
    isRequired?: boolean;
}

export class ComponentParticipant extends Participant {
    name: string;
    metadataId: string;
    methodCode: string;
    methodName: string;
    actualParameters: Array<ActualParameter>;
}

export class ReportingLineParticipant extends UserParticipant {
    reportingLineDefId: string;
    reportingLineDefName: string;
    refOrgId: string;
    refOrgName: string;
    refUserId: string;
    refEmployeeId: string;
    dimension: string;
    reportingReferObject: string;
}

export class MatrixParticipant extends UserParticipant {

    matrixDefId: string; // 用于存储字段id
    matrixDefName: string;
    conditionField1: string;
    conditionFieldText1: string;
    conditionField2: string;
    conditionFieldText2: string;
    conditionField3: string;
    conditionFieldText3: string;
    dataFieldAlias: string;
}

export class ActivityExecutorParticipant extends UserParticipant {
  activityDefId: string;
  activityDefName: string;
}

export class OrganizationParticipant extends Participant {
    name: string;
    actionScope: ActionScope;
    organizationLevel: OrganizationLevel;
    organizationId: string ;
    organizationCode: string ;
    organizationName: string ;
    includeChildren: boolean ;
    parentsUntil: boolean;
    tag: string;
}

export enum ActionScope {
    /**
     * 指派
     */
    AssignUser = 'AssignUser',
    /**
     * 移交
     */
    Transfer = 'Transfer',
    /**
     * 征询
     */
    AddSignFront = 'AddSignFront',
    /**
     * 加签
     */
    AddSignBehind = 'AddSignBehind',
    /**
     * 知会
     */
    Notify = 'Notify',
}
export enum OrganizationLevel {
    /**
     * 部门
     */
    DEPARTMENT = 'DEPARTMENT',
    /**
     * 单位
     */
    UNIT = 'UNIT',
    /**
    * 默认值
    */
    DEFAULT = 'DEFAULT',

    VARORGANIZATION = 'VARORGANIZATION'

    // ASSIGNORGANIZATION = 'ASSIGNORGANIZATION'
}


export class ActualParameter {
    code: string;
    value: string;
    valueText: string;
    tag: string;
    fetchValueMode?: any;
    fetchValueSetting?: any;
}

